import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAditivosRecursoConcedidoInicio: [],
    buscaAditivosRecursoConcedidoSucesso: ['aditivosRecursoConcedido'],
    buscaAditivosRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAditivosRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAditivosRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarAditivos(filtro)
            .then(response => dispatch(Creators.buscaAditivosRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAditivosRecursoConcedidoErro(error)))
    }
}

const buscaAditivosRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAditivosRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaAditivosRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.aditivosRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ADITIVOS_RECURSO_CONCEDIDO_INICIO]: buscaAditivosRecursoConcedidoInicio,
    [Types.BUSCA_ADITIVOS_RECURSO_CONCEDIDO_ERRO]: buscaAditivosRecursoConcedidoErro,
    [Types.BUSCA_ADITIVOS_RECURSO_CONCEDIDO_SUCESSO]: buscaAditivosRecursoConcedidoSucesso,
})
